import { render, staticRenderFns } from "./detalleArqueoCaja.vue?vue&type=template&id=278cfede&"
import script from "./detalleArqueoCaja.vue?vue&type=script&lang=js&"
export * from "./detalleArqueoCaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports